import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import OperationCardPrint from '../../components/OperationCardPrint'

function Impressao() {
  const store = useSelector((reduxState) => reduxState)

  return (
    <div style={{ background: '#ffffff', marginTop: -20 }}>
      <OperationCardPrint></OperationCardPrint>
    </div>
  )
}

export default Impressao
